export const PREBUILD_ICONS_BY_SLUG = {
	"starter-plus": {
		class: "cross",
		icon: "&#10010;"
	},
	"starter-pro": {
		class: "diamond",
		icon: "&#10022;"
	}
};
